// extracted by mini-css-extract-plugin
module.exports = {"container":"Columns--styles-module_container-3J7H9","column":"Columns--styles-module_column-36nzc","forceMobile":"Columns--styles-module_forceMobile-1T2qI"};